import { AppRole } from '@/constants/roles';
import { clientStatusLabel, resolveClientStatusKey } from '@/utils/statusTransitions';

export { clientStatusLabel, exitReasonLabel, lastActivityAt, matchesStatusFilter, resolveClientStatusKey, STATUS_FILTER_OPTIONS, isExited } from '@/utils/statusTransitions';


export interface ServiceRecord {
  date: string;
  metro: number;
  laundry: number;
  meal: number;
  juice: number;
}

// Child interface for family shelters
export interface FamilyChild {
  name: string;
  age?: number;
  dateOfBirth?: string;
}

export interface Client {
  id: string;
  name: string;
  age: number;
  room?: string;
  room_id?: string;
  site_id?: string;
  site_name?: string;
  siteName?: string;
  status: 'checked-in' | 'checked-out' | 'unbedded' | 'not_present' | 'reserved' | 'waitlist';
  caseWorker: string;
  case_worker_id?: string;
  phone?: string;
  email?: string;
  address?: string;
  
  // allergies removed — Cimfoni stores no PHI
  alerts?: string[];
  checkInTime?: string;
  checkOutTime?: string;
  lastActivity?: string;
  photo?: string;
  emergencyContact?: {
    name: string;
    relationship: string;
    phone: string;
  };
  services?: {
    daily: ServiceRecord;
    total: ServiceRecord;
  };
  isReturnee?: boolean;
  returneeObservations?: string;
  passStart?: string;
  passEnd?: string;
  passType?: string;
  // Family shelter fields
  isHeadOfHousehold?: boolean;
  partnerId?: string;
  partnerName?: string;
  children?: FamilyChild[];
  propertyStorageNotes?: string;
  // Exit tracking
  exitReason?: string | null;
  exitedAt?: string | null;

}

// Display status — thin wrapper over the single status engine.
export const getDisplayStatus = (client: Client): { status: string; isOnPass: boolean; passEnd?: string } => {
  const key = resolveClientStatusKey(client as any);
  return {
    status: clientStatusLabel(client as any),
    isOnPass: key === 'pass',
    passEnd: key === 'pass' ? client.passEnd : undefined,
  };
};


export interface User {
  id: string;
  username: string;
  role: AppRole;
  name: string;
}

export interface AlertAcknowledgement {
  id: string;
  alertId: string;
  userId: string;
  acknowledgedAt: string;
  userName?: string;
}

export interface Alert {
  id: string;
  type: 'critical' | 'warning' | 'info';
  title: string;
  description: string;
  timestamp: string;
  status: 'active' | 'resolved' | 'archived';
  createdBy?: string;
  acknowledgedBy?: string;
  clientId?: string;
  category?: 'client' | 'staff' | 'service' | 'building' | 'system';
  acknowledgements?: AlertAcknowledgement[];
}

export interface SystemMetrics {
  cpu: number;
  memory: number;
  network: number;
  database: number;
}

export interface RosterClient {
  clientId: string;
  name: string;
  room: string;
  subRoom?: string; // For 103a, 103b designations
  hasAssignedRoom: boolean;
}